// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"_8dbe26e1","outerContainer":"_08a2948e","secondaryToolbar":"_53c263b7","doorHangerRight":"e54331c0","toolbarContainer":"_1c8a0408","toolbarViewerMiddle":"f17cfb6b","progressBar":"_51978009","back-to-application":"_87eb9246","wrapper":"_10c80a9c","content":"_772bed69","sectionTitle":"_301dd0a3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ProfileLayout/ProfileDocumentation/PaperConsents/index.styl
// module id = 5088
// module chunks = 39